import { Badge } from '@neo/primitives/badge'
import { ExternalLink } from 'lucide-react'
import type { RJudgeVerdict } from 'v2/types/api/agent-observability'

/** Deep-link a call into the Agent Runs view, keyed by flow_run_uuid. Opens in a new tab.
 *  runId must be a real flow_run_uuid — session_id resolves to no run there, so RunLink
 *  hides the link when it's absent rather than pointing at a wrong-but-plausible id. */
export const openAgentRun = (flowId: string, runId: string) =>
  window.open(`${window.location.origin}/agent-runs/${flowId}/${runId}`, '_blank', 'noopener')

export const RunLink = ({
  flowId,
  sessionId,
  runId,
}: {
  flowId: string
  sessionId: string
  runId?: string | null
}) => (
  <span className="inline-flex items-center gap-1">
    <span className="text-p-400 text-primary font-mono">{sessionId.slice(0, 8)}</span>
    {runId ? (
      <button
        type="button"
        onClick={() => openAgentRun(flowId, runId)}
        className="text-tertiary hover:text-primary"
        aria-label="Open in Agent Runs"
        data-testid={`link-agent-run-${sessionId}`}
      >
        <ExternalLink size={13} />
      </button>
    ) : null}
  </span>
)

export const verdictBadge = (verdict: RJudgeVerdict | null) => {
  if (verdict === 'pass') return <Badge variant="success">Passed</Badge>
  if (verdict === 'fail') return <Badge variant="danger">Failed</Badge>
  return <Badge variant="disabled">Unknown</Badge>
}

/** A session AO could not judge at all (`available: false`) — not an uncertain verdict,
 *  and never eligible as a calibration example. */
export const notScoredBadge = () => <Badge variant="disabled">Not scored</Badge>

export const oppositeVerdict = (v: RJudgeVerdict | null): RJudgeVerdict =>
  v === 'fail' ? 'pass' : 'fail'
